module.exports = __webpack_public_path__ + "img/Joe Willock.7806a54e.png";